<div class="input-main-container ym-display-flex ym-flex-direction-column ym-gap-2" [class.error-occured]="error">
    <div class="label-container ym-display-flex ym-align-items-center ym-gap-3" *ngIf="showLabel">
        <div class="ym-text-color ym-display-flex ym-align-items-center ym-gap-2 ym-w-full">
            <span class="text ym-font-base ym-line-height-normal">{{label}}</span>
            <span class="optional-indicator ym-text-secondary ym-display-inline-block" *ngIf="!required && !hideOptional">
                <!-- <span class="icon ym-svg-sm ym-mt-n2">
                    <ym-icon [iconName]="iconNames.REQUIRED"></ym-icon>
                </span> -->
                (optional)
            </span>
            <span class="inline-info ym-svg-base" *ngIf="inlineInfo">
                <ym-inline-info [hideTooltip]="true">
                    {{inlineInfo}}
                </ym-inline-info>
            </span>
        </div>
    </div>
    <div class="content ym-display-flex ym-gap-3">
        <!-- <ym-dropdown [showDropdown]="isEmailDropdownOpen" (onDropdownClose)="toggleEmailDropdown(false)"
            [selectionType]="dropdownSelectionTypes.DEFAULT" [position]="popoverPositions.BELOW_LEFT_START"
            [dropdownOption]="emailDropdownOptions" class="ym-w-full ym-overflow-hidden">
            <ng-container trigger> -->
        <ym-button [fullWidth]="true" [disabled]="disabled" [variant]="buttonVariants.DEFAULT"
            [icon]="iconNames.CALENDAR" [ymPopoverTrigger]="popover"
            [ymPopoverPosition]="popoverPositions.BELOW_LEFT_START" [ymPopoverOpen]="isEditDropdownOpen"
            (onPopoverClose)="toggleEditDropdown(false)" (onClick)="toggleEditDropdown(true)"
            class="email-input ym-w-full ym-overflow-hidden">
            <ng-container *ngIf="value && value.length">
                <ng-container *ngFor="let email of value;let isLast=last">
                    {{email.value}} <span class="ym-text-secondary">({{email.label}})</span><ng-container
                        *ngIf="!isLast">,</ng-container>
                </ng-container>
            </ng-container>
        </ym-button>
        <!-- </ng-container>
        </ym-dropdown> -->

        <!-- <ym-button [size]="buttonSizes.BASE" [disabled]="disabled" [type]="buttonTypes.DEFAULT"
            [variant]="buttonVariants.ICON_ONLY" [icon]="iconNames.EDIT" [tooltip]="'Edit'" class="ym-ml-auto"
            (onClick)="toggleEditDropdown(true)" *ngIf="!disabled">Edit</ym-button> -->
    </div>
    <span class="error-text ym-font-sm ym-text-danger ym-display-block ym-line-height-normal"
        *ngIf="error">{{errorText}}</span>
</div>

<ng-template #popover>
    <app-email-edit-popover [label]="label" [name]="name" [value]="value" (updateEmails)="updateValue($event)"
        (close)="toggleEditDropdown(false)"></app-email-edit-popover>
</ng-template>